import type { LocalRefLabel } from "@/utils/i18n/t11n"
import { isNotNullNorUndefined } from "@/utils/ts-utils"
import { FormattedMessage, useIntl } from "react-intl"
import { RefLabel } from "../RefLabel"

type Props = {
  min?: number | null
  max?: number | null
  unit?: LocalRefLabel | null
  dft?: string
}

export default function FormattedMinMaxUnit({ min, max, unit, dft }: Props) {
  const intl = useIntl()

  if ((min ?? 0) > 0 && (max ?? 0) > 0)
    return (
      <>
        <FormattedMessage id="between_min_and_max" values={{ min, max }} />
        {isNotNullNorUndefined(unit) && (
          <>
            {" "}
            <RefLabel label={unit} />
          </>
        )}
      </>
    )

  if ((min ?? 0) > 0)
    return (
      <>
        <FormattedMessage id="more_than" values={{ min }} />
        {isNotNullNorUndefined(unit) && (
          <>
            {" "}
            <RefLabel label={unit} />
          </>
        )}
      </>
    )

  if ((max ?? 0) > 0)
    return (
      <>
        <FormattedMessage id="less_than" values={{ max }} />
        {isNotNullNorUndefined(unit) && (
          <>
            {" "}
            <RefLabel label={unit} />
          </>
        )}
      </>
    )

  return <>{dft ?? "-"}</>
}
